{
  "releaseNotes": [
    {
      "release": "0.92.98",
      "contents": [
        {
          "title": "Nyheter",
          "notes": [
            {
              "note": "Möjlighet att spara kranspetskoordinat och RTK på Maskin."
            }
          ]
        },
        {
          "title": "Förbättringar",
          "notes": [
            {
              "note": "Möjlighet att filtrera och sortera i Maskinprestation."
            },
            {
              "note": "Justeringar i listvy Maskinprestation."
            }
          ]
        }
      ]
    },
    {
      "release": "1.1.2",
      "contents": [
        {
          "title": "Nyheter",
          "notes": [
            {
              "note": "Stöd för demomaskiner."
            }
          ]
        },
        {
          "title": "Förbättringar",
          "notes": [
            {
              "note": "Sparade poster visar nu endast namnet på användaren."
            }
          ]
        }
      ]
    },
    {
      "release": "1.1.1",
      "contents": [
        {
          "title": "Förbättringar",
          "notes": [
            {
              "note": "Korrigerad validering Avverkningsföretag-Id."
            },
            {
              "note": "Nytt tecken för \"ogiltigt värde\"."
            }
          ]
        }
      ]
    },
    {
      "release": "1.1.0",
      "contents": [
        {
          "title": "Nyheter",
          "notes": [
            {
              "note": "Namn och e-postadress på den användare som sparar maskin eller maskinlag visas tillsammans med ändringsdatum och tid."
            }
          ]
        },
        {
          "title": "Förbättringar",
          "notes": [
            {
              "note": "Förenklad hantering av att uppdatera standardprestation för maskin."
            },
            {
              "note": "Tydligare visning av hjälptext i kombination med knappar."
            },
            {
              "note": "Möjlighet att välja entreprenör med status \"Årlig kontroll.\""
            },
            {
              "note": "Val ansvarig entreprenör för maskin kan i vissa fall automatisk inkopiera Avverkningsföretag-ID."
            }
          ]
        },
        {
          "title": "Felrättningar",
          "notes": [
            {
              "note": "Justering av hantering av maskinens status."
            },
            {
              "note": "Justering av visning av tillverkare och modell för maskin."
            }
          ]
        }
      ]
    },
    {
      "release": "1.0.0",
      "contents": [
        {
          "title": "FoMa - Nytt maskinregister",
          "notes": [
            {
              "note": "FoMa är ett register över skördare, skotare och maskinlag och ersätter CSR."
            },
            {
              "note": "FoMa är integrerat med flera andra system i virkesflödet"
            },
            {
              "note": "Datum för release 2025-11-26."
            }
          ]
        }
      ]
    }
  ]
}
